export const profileLinkServices = [
  {
    id: 'website',
    nicename: 'Website',
    descriptor: 'Website URL',
    baseUrl: 'https://',
    urlReplace: [],
  },
  {
    id: 'psn',
    nicename: 'PlayStation Network',
    descriptor: 'Gamertag',
    baseUrl: 'https://my.playstation.com/profile/',
    urlReplace: [
      'www.my.playstation.com/profile',
      'my.playstation.com/profile',
    ],
  },
  {
    id: 'xbox-live',
    nicename: 'Xbox Live',
    descriptor: 'Gamertag',
    baseUrl: 'https://live.xbox.com/Profile?Gamertag=',
    urlReplace: [
      'www.live.xbox.com/Profile?Gamertag=',
      'live.xbox.com/Profile?Gamertag=',
    ],
  },
  {
    id: 'discord-server',
    nicename: 'Discord Server Invite',
    descriptor: 'Invite code',
    baseUrl: 'https://discord.gg/',
    urlReplace: [
      'www.discord.com/invite',
      'discord.com/invite',
      'www.discord.com',
      'www.discord.gg',
      'discord.gg',
      'discord.com',
    ],
  },
  {
    id: 'twitter',
    nicename: 'X (Twitter)',
    descriptor: 'Username',
    baseUrl: 'https://twitter.com/',
    urlReplace: ['www.twitter.com', 'twitter.com', 'www.x.com', 'x.com'],
  },
  {
    id: 'instagram',
    nicename: 'Instagram',
    descriptor: 'Username',
    baseUrl: 'https://instagram.com/',
    urlReplace: ['www.instagram.com', 'instagram.com'],
  },
  {
    id: 'facebook',
    nicename: 'Facebook',
    descriptor: 'Username',
    baseUrl: 'https://facebook.com/',
    urlReplace: ['www.facebook.com', 'facebook.com'],
  },
  {
    id: 'facebook-gaming',
    nicename: 'Facebook Gaming',
    descriptor: 'Username',
    baseUrl: 'https://facebook.com/',
    urlReplace: ['www.facebook.com', 'facebook.com'],
  },
  {
    id: 'twitch',
    nicename: 'Twitch',
    descriptor: 'Username',
    baseUrl: 'https://twitch.tv/',
    urlReplace: ['www.twitch.tv', 'clips.twitch.tv', 'twitch.tv'],
  },
  {
    id: 'tiktok',
    nicename: 'TikTok',
    descriptor: 'Username',
    baseUrl: 'https://tiktok.com/',
    urlReplace: ['www.tiktok.com', 'tiktok.com'],
  },
  {
    id: 'youtube',
    nicename: 'YouTube',
    descriptor: 'Channel URL or handle',
    baseUrl: 'https://youtube.com/',
    urlReplace: ['www.youtube.com', 'youtube.com', 'www.youtu.be', 'youtu.be'],
  },
]

export const profileLinkServiceIds = profileLinkServices.map(
  (service) => service.id,
)

export function getProfileLinkService(serviceId) {
  return profileLinkServices.find((service) => service.id === serviceId)
}

export function formatProfileLinkValue(serviceId, value) {
  const service = getProfileLinkService(serviceId)

  if (!service || typeof value !== 'string') return ''

  let formattedValue = value.trim().replace(/^https?:\/\//i, '')

  const matchingPrefix = service.urlReplace.find((replace) =>
    formattedValue.toLowerCase().startsWith(replace.toLowerCase()),
  )

  if (matchingPrefix) {
    formattedValue = formattedValue.slice(matchingPrefix.length)
  }

  if (serviceId !== 'website') {
    formattedValue = formattedValue.split(/[?#&]/, 1)[0]
  }

  return formattedValue.replace(/^\/+|\/+$/g, '').trim()
}

export function getProfileLinkUrl(serviceId, value) {
  const service = getProfileLinkService(serviceId)
  const formattedValue = formatProfileLinkValue(serviceId, value)

  if (!service || !formattedValue) return null

  return `${service.baseUrl}${formattedValue}`
}
